module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsWomen@2x.65a8b4b.jpg";